const mobileProductReviews = $('.product-reviews-mobile');

if (window.innerWidth > 991) {
  mobileProductReviews.remove();
}

function toBoolean(value) {
  if (typeof value === 'string') {
    value = value.toLowerCase();
  }
  if (value === 'true') {
    value = true;
  } else if (value === 'false') {
    value = false;
  }

  return value;
}

/* global reviews, POWERREVIEWS */
/* eslint-disable camelcase */
window.HMSPowerReviews = class HMSPowerReviews {
  constructor() {
    this.reviewsToRender = [];
    this.init();
  }

  renderReviews($control) {
    const pageId = $control.data('pageid');
    const controlId = $control.attr('id');
    const components = {};

    const review = {
      locale: reviews.locale,
      merchant_group_id: reviews.merchantGroupId,
      merchant_id: reviews.merchantId,
      api_key: reviews.apiKey,
      page_id: pageId,
      subject: {
        '@context': 'https://schema.org',
        '@type': 'Product',
        id: reviews.reviewCurrentUrl,
        name: reviews.reviewProductName,
        description: reviews.reviewDescription,
        image: reviews.reviewImgUrl,
        sku: reviews.reviewSku,
        brand: reviews.brand
      },
      components: components
    };

    const reviewType = $control.data('reviewtype');
    switch (reviewType) {
      case 'ReviewForm':
        components.Write = controlId;
        POWERREVIEWS.display.render(review);
        break;
      case 'Category':
        components.CategorySnippet = controlId;
        this.reviewsToRender.push({
          ...review,
          ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false
        });
        break;
      case 'ReviewDisplay':
        components.ReviewDisplay = controlId;
        review.REVIEW_DISPLAY_SNAPSHOT_TYPE = 'SIMPLE';
         this.reviewsToRender.push({
          ...review,
          ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false
        });
        break;
      case 'Review':
        components.ReviewSnippet = controlId;
         this.reviewsToRender.push({
          ...review,
          ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false
        });
        break;
    }
  }

  checkReviewByPageId($control, reviewtype) {
    const pageId = $control.data('pageid');
    const controlId = $control.attr('id');
    let reviewFound = false;
    $(this.reviewsToRender).each((index, currentReview) => {
      if (!reviewFound) {
        if (
          currentReview.page_id === pageId &&
          (currentReview.components.ReviewSnippet ||
            currentReview.components.ReviewDisplay)
        ) {
          if (reviewtype === 'Review') {
            currentReview.components.ReviewSnippet = controlId;
          } else if (reviewtype === 'ReviewDisplay') {
            currentReview.components.ReviewDisplay = controlId;
            currentReview.REVIEW_DISPLAY_SNAPSHOT_TYPE = 'SIMPLE';
          }
          reviewFound = true;
        }
      }
    });
    if (!reviewFound) {
      this.renderReviews($control);
    }
  }

  setupTracking($control) {
    if (!POWERREVIEWS.tracker) {

      return;
    }
    const pageId = String($control.data('pageid'));
    const sampleItemNames = $control.data('sampleitemname').split('|');

    const tracker = POWERREVIEWS.tracker.createTracker({
      merchantGroupId: reviews.merchantGroupId
    });
    const orderItems = [];
    $(pageId.split(',')).each((index, text) => {
      orderItems.push({
        page_id: text,
        product_name: sampleItemNames.length > index ? sampleItemNames[index] : '',
        quantity: 1,
        unit_price: 1.0
      });
    });

    tracker.trackCheckout({
      merchantGroupId: reviews.merchantGroupId,
      merchantId: reviews.merchantId,
      locale: reviews.locale,
      marketingOptIn: toBoolean($control.data('futureoptin')),
      userEmail: $control.data('email'),
      merchantUserId: $control.data('email'),
      userFirstName: $control.data('firstname') || '',
      userLastName: $control.data('lastname'),
      orderId: $control.data('orderid'),
      orderItems
    });
  }

  init() {
    try {
      this.reviewsToRender.length = 0;
      const $controls = $('.js-review');
      if ($controls.length) {
        $controls.each((index, control) => {
          const $control = $(control);

          const reviewType = $control.data('reviewtype');
          switch (reviewType) {
            case 'CheckoutBeacon':
              this.setupTracking($control);
              break;
            case 'Category':
            case 'ReviewForm':
              this.renderReviews($control);
              break;
            case 'ReviewDisplay':
            case 'Review':
              this.checkReviewByPageId($control, reviewType);
              break;
          }
        });

        if (this.reviewsToRender.length) {
          window.pwr = window.pwr || function () {
            // eslint-disable-next-line id-length
            (window.pwr.q = window.pwr.q || []).push(arguments);
          };
          window.pwr('render', this.reviewsToRender );
        }
      }
    } catch (e) {
      window.console && window.console.error && window.console.error(e);
    }
  }
}